import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  className?: string;
};

const LineIcon = ({ size, className }: Props) => (
  <Root xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} className={className}>
    <g id="FULL_COLOR_ICON_2_">
      <path
        fill="#00b900"
        d="M18.8 24H5.2C2.3 24 0 21.7 0 18.8V5.2C0 2.3 2.3 0 5.2 0h13.6C21.7 0 24 2.3 24 5.2v13.6c0 2.9-2.3 5.2-5.2 5.2z"
      />
      <g id="TYPE_A_1_">
        <path
          d="M20.7 10.9c0-3.9-3.9-7.1-8.7-7.1-4.8 0-8.7 3.2-8.7 7.1 0 3.5 3.1 6.4 7.3 7 .3.1.7.2.8.4.1.2.1.6 0 .8 0 0-.1.6-.1.7 0 .2-.2.9.8.5.9-.4 5-3 6.9-5.1 1.1-1.3 1.7-2.7 1.7-4.3"
          fill="#fff"
        />
        <path
          fill="#00b900"
          d="M10.2 9.1h-.6c-.1 0-.2.1-.2.2V13c0 .1.1.2.2.2h.6c.1 0 .2-.1.2-.2V9.2c0-.1-.1-.1-.2-.1M14.4 9.1h-.6c-.1 0-.2.1-.2.2v2.3l-1.7-2.4h-.6c-.3-.1-.3-.1-.3 0V13c0 .1.1.2.2.2h.6c.1 0 .2-.1.2-.2v-2.3l1.7 2.4h.6c.1 0 .2-.1.2-.2V9.2c.1-.1 0-.1-.1-.1M8.7 12.2H7v-3c0-.1 0-.1-.1-.1h-.6c-.1 0-.2.1-.2.2V13.1h2.5c.1 0 .2-.1.2-.2v-.6c.1 0 0-.1-.1-.1M17.8 10c.1 0 .2-.1.2-.2v-.6c0-.1-.1-.2-.2-.2h-2.4-.1v4.1h2.5c.1 0 .2-.1.2-.2v-.6c0-.1-.1-.2-.2-.2h-1.7v-.6h1.7c.1 0 .2-.1.2-.2v-.6c0-.1-.1-.2-.2-.2h-1.7V10h1.7z"
        />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default LineIcon;
